import {Component, Input, OnInit} from '@angular/core';
import {UserDataService} from '../../../modules/auth/user-data.service';
import {UserInfoService} from "../../../../user-info.service";

@Component({
    selector: 'app-check-current-user',
    templateUrl: './check-current-user.component.html',
    styleUrls: ['./check-current-user.component.scss']
})
export class CheckCurrentUserComponent implements OnInit {
    email: string;


    constructor(private userInfoService: UserInfoService) {}

    getEmail(): void {
        this.userInfoService.getMainData().subscribe(user => {
            this.email = user['email'];
        });
    }
    
    onLogout(){
        localStorage.removeItem("loggedIn");
    }

    ngOnInit(): void {
        this.getEmail();
    }

}
